import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NavController, ViewController, Events, LoadingController } from 'ionic-angular';
import { AuthenticationComponent } from '../../authentication.component';
import { UploadResumeService } from '../../../../../../../UI/src/app/shared/upload-resume/upload-resume.service';
import { SettingsService } from '../../../../../../../UI/src/app/shared/settings/settings.service';
import { SitemapService } from '../../../../../../../UI/src/app/shared/sitemap/sitemap.service';
import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { ToastControllerService } from '../../../../../providers/toast-controller.service';
import { ScriptLoadService } from '../../../../../../../UI/src/app/core/script-load/script-load.service';
import { TranslateService } from '@ngx-translate/core';
import { Toast508Service } from '../../../../../providers/toast-508.service';
import { ReviewCandidateProfileComponent } from '../../../review-candidate-profile/review-candidate-profile.component';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { AuthenticationService } from '../../../../../../../UI/src/app/shared/authentication/authentication.service';
import { EditProfileComponent } from '../../../edit-profile/edit-profile.component';

declare var gapi: any;
declare var auth: any;
declare var google: any;
declare var Dropbox: any;
@Component({
  selector: 'popup-upload-resume',
  templateUrl: 'upload-resume-popup.component.html'
})
export class UploadResumePopupComponent implements OnInit, AfterViewInit {
  authenticationComponent: any = AuthenticationComponent;
  private partnerAccountSettings: any;
  public enableGDriveSetting: any;
  public enableDropboxSetting: any;
  private enablegDrive = 'REC_ENABLE_GDRIVE_UPLOAD';
  private enableDropbox = 'REC_ENABLE_DROPBOX_UPLOAD';
  private getGDriveClientId = 'REC_GDRIVE_CLIENTID';
  private getGDriveDevKey = 'REC_GDRIVE_DEVELOPERKEY';
  private getGDriveAppId = 'REC_GDRIVE_APPID';
  private getDropboxAppKey = 'REC_DROPBOX_APPKEY';
  private gDriveClientID: any;
  private gDriveDevKey: any;
  private gDriveAppID: any;
  private gDriveScope = 'https://www.googleapis.com/auth/drive';
  private gDriveDownloadRoot = 'https://www.googleapis.com/drive/v3/files'
  private dropBoxAppKey: any;
  private clientId = '';
  private pickerApiLoaded = false;
  private oauthToken;
  private auth2: any;
  private options;
  private authResult: any;
  private alertData: any;
  private getFileSizeKey = 'ELIXHRUI_SUPPORTED_FILE_SIZE';
  public fileSizeSetting: any;
  private fileSizeExceedMessage: any;
  private fileTypeSetting: any;
  private getFileTypeKey = 'ELIXHRUI_RESUME_SUPPORTED_FILE_TYPES';
  resumeExists: boolean = false;
  attributes: any;
  private loading;
  translations: any;
  public resumeAction: any;
  private tokenClient: any;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    private uploadResumeService: UploadResumeService,
    private resumeService: ResumeService,
    private settingsService: SettingsService,
    private sitemapService: SitemapService,
    private profileService: ProfileService,
    public events: Events,
    private toastService: ToastControllerService,
    private scriptloadService: ScriptLoadService,
    public loadingCtrl: LoadingController,
    private translate: TranslateService,
    private toast508Service: Toast508Service,
    private authenticationService: AuthenticationService,
  ) {
    this.loading = this.loadingCtrl.create({
      duration: 15000
    });

      translate.get(['CAREER_RESUME_INVALID_FILE',
                   'CAREER_RESUME_FILE_SIZE',
                   'CAREER_RESUME_DRIVE_UPLOAD_SUCCESS',
                   'CAREER_RESUME_UPLOAD_FAIL',
                   'CAREER_RESUME_IMPORT_DROPBOX_FAIL',
                   'CAREER_RESUME_UPLOAD_NO_FILES',
                   'CAREER_RESUME_IMPORT_GOOGLEDRIVE_FAIL'])
            .subscribe((translationsObj) => {
              this.translations = translationsObj;
            });

            this.resumeAction = this.resumeService.getResumeAction();
  }

  onClose() {
    this.viewCtrl.dismiss(this.alertData);
  }

  ngAfterViewInit(){
    setTimeout(() => {
      let elm = <HTMLDivElement>document.querySelector('ion-modal div');
      if(elm != null) {
        elm.setAttribute('tabindex','-1');
        elm.setAttribute('role','dialog');
        elm.focus();
      }
    },300)
  }


  ngOnInit() {
    this.settingsService.GetSettings().subscribe(
      settings => {
        this.partnerAccountSettings = settings;
        if (this.partnerAccountSettings) {
          this.enableGDriveSetting = this.partnerAccountSettings.filter(setting => setting.key === this.enablegDrive)[0].value;
          this.enableDropboxSetting = this.partnerAccountSettings.filter(setting => setting.key === this.enableDropbox)[0].value;
          this.fileSizeSetting = this.partnerAccountSettings.filter(setting => setting.key === this.getFileSizeKey)[0].value;
          this.fileSizeExceedMessage = this.translations['CAREER_RESUME_FILE_SIZE'].replace('{{limit}}', this.fileSizeSetting / (1024 * 1024));
          this.fileTypeSetting = this.partnerAccountSettings.filter(setting => setting.key === this.getFileTypeKey)[0].value;
          if (this.enableGDriveSetting === 'True') {
            this.gDriveClientID = this.partnerAccountSettings.filter(setting => setting.key === this.getGDriveClientId)[0].value;
            this.gDriveDevKey = this.partnerAccountSettings.filter(setting => setting.key === this.getGDriveDevKey)[0].value;
            this.gDriveAppID = this.partnerAccountSettings.filter(setting => setting.key === this.getGDriveAppId)[0].value;
            if(this.gDriveClientID){
              this.scriptloadService.load('googleApi', null, null, 'gsi')
              .then(data => this.onLoadCallback())
              .catch(error => console.log(error));
            }
          }
          if (this.enableDropboxSetting === 'True') {
            this.dropBoxAppKey = this.partnerAccountSettings.filter(setting => setting.key === this.getDropboxAppKey)[0].value;
            if (this.dropBoxAppKey) {
              this.attributes = [{ name: 'data-app-key', value: this.dropBoxAppKey }];
              this.scriptloadService.load('dropboxChooser', null, this.attributes, 'dropboxjs').then(data => {
                console.log('script loaded ', data);
              }).catch(error => console.log(error));
            }
          }
        }
      }
    );

    if (this.resumeExists === false) {
      this.profileService.getProfileData().subscribe(profileData => {
        if (profileData[0].resumeType !== 0) {
          this.resumeExists = true;
        }
      });
    }
  }

  fileChange(event) {
    if (event && event.target.files) {
      const fileList: FileList = event.target.files;
      if (fileList.length > 0) {
        const file: File = fileList[0];
        const filevalid = this.checkFileFormat(file.name, file.size);
        if (filevalid.sizeofFile && filevalid.typeofFile) {
        const formData: FormData = new FormData();
        formData.append('DisplayName', file.name);
        formData.append('Description', 'Resume Import from Local Drive');
        formData.append('uploadFile', file);
        this.formDataUpload(formData);        
      } else {
        if (!filevalid.typeofFile) {
          this.alertData = { message: this.translations['CAREER_RESUME_INVALID_FILE'], type: 'error' };
        } else if (!filevalid.sizeofFile) {
          this.alertData = { message: this.fileSizeExceedMessage, type: 'error' };
        }
        this.viewCtrl.dismiss(this.alertData);
        this.toastService.presentToast(this.alertData);
        this.toast508Service.toFocus();       
      }
    }
  }
}

  private checkFileFormat(name, size) {
   const importResumeFileParams = {
     fileSize : this.fileSizeSetting,
     fileType : this.fileTypeSetting == null ? null : this.fileTypeSetting.split(',')
   };
   const fileParams = {
     typeofFile: false,
     sizeofFile: false
    };
   if (importResumeFileParams.fileType.indexOf(name.substring(name.lastIndexOf('.'))) !== -1) {
     fileParams.typeofFile = true;
     if ( size <=  importResumeFileParams.fileSize) {
       fileParams.sizeofFile = true;
     }
     return fileParams;
   } else {
     return fileParams;
   }
  }

  /*Google Drive file Upload logic start*/
  public onLoadCallback() {
    this.tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: this.gDriveClientID,
      scope: this.gDriveScope,
      callback: (authResult) => {
        if (authResult && !authResult.error) {
          this.oauthToken = authResult.access_token;
          this.createPicker();
        }
      }
    });
  }

  /*Load Drive API*/
  private loadDriveApi() {
    gapi.client.load('drive', 'v3', this.listFiles);
  }

  /*Initiate auth flow in response to user clicking authorize button.*/
  private handleAuthClick = function (event) {
    gapi.auth.authorize(
      {
        client_id: this.gDriveClientID,
        scope: this.gDriveScope,
        immediate: false
      },
      () => {
        const authorizeDiv = document.getElementById('authorize-div');
        if (this.authResult && !this.authResult.error) {
          // Hide auth UI, then load client library.
          authorizeDiv.style.display = 'none';
          this.loadDriveApi();
        } else {
          // Show auth UI, allowing the user to initiate authorization by
          // clicking authorize button.
          authorizeDiv.style.display = 'inline';
        }
      });
    return false;
  };

  /*Print Files*/
  private listFiles() {
    const request = gapi.client.drive.files.list({
      'pageSize': 10,
      'fields': 'nextPageToken, files(id, name)'
    });
    request.execute(function (resp) {
      this.appendPre('Files:');
      const files = resp.files;
      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          this.appendPre(file.name + ' (' + file.id + ')');
        }
      } else {
        this.appendPre(this.translations['CAREER_RESUME_UPLOAD_NO_FILES']);
      }
    });
  }

  /*Create and render a Picker object for searching images*/
  private createPicker() {
    if (this.oauthToken) {
      const view = new google.picker.DocsView(google.picker.ViewId.DOCS);   // google.picker.ViewId.DOCS : Show all doc types.
      view.setIncludeFolders(true);   // Show folders
      view.setParent('root'); // Show from root directory
      // TODO: Filter by supported mime type
      // view.setMimeTypes('application/vnd.google-apps.folder');
      const picker = new google.picker.PickerBuilder()
        .enableFeature(google.picker.Feature.MINE_ONLY)
        // .setLocale('fr')  // TODO: Set Locale, Supported Locale: https://developers.google.com/picker/docs/#gdata
        .setAppId(this.gDriveAppID)
        .setOAuthToken(this.oauthToken)
        .addView(view)
        .setSize(200, 500)
        .setCallback(this.pickerCallback)
        .setDeveloperKey(this.gDriveDevKey)
        .build();
      picker.setVisible(true);
    }
  }

  /*Picker callback implementation*/
  private pickerCallback = (data) => {
    if (data && data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
      const doc = data[google.picker.Response.DOCUMENTS][0];
      const filevalid = this.checkFileFormat(doc.name, doc.sizeBytes);
      const fileId = doc[google.picker.Document.ID];
      if (filevalid.sizeofFile && filevalid.typeofFile) {
        const downloadUrl = `${this.gDriveDownloadRoot}/${fileId}?alt=media`;
        const uploadFrom = 'Resume Import from Google Drive';
        const accessToken = this.oauthToken;
        const xhr = new XMLHttpRequest();
        xhr.open('GET', downloadUrl);
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          this.uploadBinary(xhr.response, doc.name, uploadFrom);
        };
        xhr.onerror = () => {
          this.alertData = { message: this.translations['CAREER_RESUME_IMPORT_GOOGLEDRIVE_FAIL'], type: 'error' };
          this.viewCtrl.dismiss(this.alertData);
          this.toastService.presentToast(this.alertData);
          this.toast508Service.toFocus();
        };
        xhr.send();
      } else {
        if (!filevalid.typeofFile) {
          this.alertData = { message: this.translations['CAREER_RESUME_UPLOAD_NO_FILES'], type: 'error' };
        } else if (!filevalid.sizeofFile) {
          this.alertData = { message: this.fileSizeExceedMessage, type: 'error' };
        }
      }
    }
  }

  /*Append a pre element to the body containing the given message as its text node*/
  private appendPre(message) {
    const pre = document.getElementById('output');
    const textContent = document.createTextNode(message + '\n');
    pre.appendChild(textContent);
  }

  /*Load Google Drive Picker*/
  loadPicker() {
    gapi.load('client:picker', { 'callback': this.onPickerApiLoad.bind(this) });
  }

  private onAuthApiLoad() {
    gapi.auth.authorize({
      'client_id': this.gDriveClientID,
      'scope': this.gDriveScope,
      'immediate': false
    },
      (authResult) => {
        if (authResult && !authResult.error) {
          this.oauthToken = authResult.access_token;
          this.createPicker();
        }
      });
  }

  private onPickerApiLoad() {
    this.pickerApiLoaded = true;
    if (this.oauthToken === null) {
      // Prompt the user to select a Google Account and ask for consent to share their data
      // when establishing a new session.
      this.tokenClient.requestAccessToken({prompt: 'consent'});
    } else {
      // Skip display of account chooser and consent dialog for an existing session.
      this.tokenClient.requestAccessToken({prompt: ''});
    }
  }

  private uploadBinary(file, displayName, uploadFrom) {
    const formData: FormData = new FormData();
    formData.append('DisplayName', displayName);
    formData.append('Description', uploadFrom);
    formData.append('uploadFile', file, displayName);
    this.formDataUpload(formData);
  }

  private formDataUpload(formData) {
    if (formData) {
      this.loading.present();
      this.uploadResumeService.uploadResume(formData).then(res => {
        if (res) {
          const data = res;
          if (data) {
            const fileId = JSON.parse(data['returnData']).id;
            const fileName = JSON.parse(data['returnData']).fileName;
            if (fileId) {
              this.uploadResumeService.saveResumeData('sovren', null, null, fileId, fileName).subscribe(resumeResult => {
                this.loading.dismiss();
                if (resumeResult) {
                  this.alertData = { message: this.translations['CAREER_RESUME_DRIVE_UPLOAD_SUCCESS'], type: 'success' };
                  if (!this.resumeExists) {
                    this.sitemapService.updateSitemapData();
                    this.resumeExists = true;
                  }
                  this.events.publish('showSiteMapNodes', true);
                  this.viewCtrl.dismiss(this.alertData);
                  let resumeObj = this.resumeService.getResumeAction();
                  if (resumeObj !== null && resumeObj.action === "EDIT_RESUME") {
                    this.authenticationService.isAppliedwithLinkedIn = false;
                  }
                  let isApply = this.resumeAction.isJobApply === undefined || this.resumeAction.isJobApply === null ? false : this.resumeAction.isJobApply;
                  if( resumeObj.action === 'REVIEW_RESUME' ) {
                  this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: true, isJobApply: isApply });
                  this.navCtrl.push(AuthenticationComponent, {"action": "REVIEW_RESUME", "isJobApply": isApply});
                  } else {
                    this.resumeService.setResumeAction({ action: 'EDIT_RESUME', isInititalCreation: false });
                    this.navCtrl.push(EditProfileComponent);
                  }
                } else {
                  this.alertData = { message: this.translations['CAREER_RESUME_UPLOAD_FAIL'], type: 'error' };
                  this.viewCtrl.dismiss(this.alertData);
                }
                this.toastService.presentToast(this.alertData);
                this.toast508Service.toFocus();
              });
            }
          }
        } else {
          this.alertData = { message: this.translations['CAREER_RESUME_UPLOAD_FAIL'], type: 'error' };
          this.viewCtrl.dismiss(this.alertData);
          this.toastService.presentToast(this.alertData);
          this.toast508Service.toFocus();
        }
      });
    }
  }

  public getDropboxPicker() {
    if (Dropbox.isBrowserSupported()) {
      this.options = {
        // Required. Called when a user selects an item in the Chooser.
        success: (files) => {
          if (files) {
            const filevalid = this.checkFileFormat(files[0].name, files[0].bytes);
            if (filevalid.sizeofFile && filevalid.typeofFile) {
            const fileName = files[0].name;
            const uploadFrom = 'Resume Import from DropBox';
            const xhr = new XMLHttpRequest();
            xhr.open('GET', fileName.link);
            xhr.responseType = 'blob';
            xhr.onload = () => {
              this.uploadBinary(xhr.response, fileName.name, uploadFrom);
            };
            xhr.onerror = function () { };
            xhr.send();
          } else {
            if (!filevalid.typeofFile) {
              this.alertData = { message: this.translations['CAREER_RESUME_INVALID_FILE'], type: 'error' };
          } else if (!filevalid.sizeofFile) {
            this.alertData = { message: this.fileSizeExceedMessage, type: 'error' };
          }
            this.viewCtrl.dismiss(this.alertData);
            this.toastService.presentToast(this.alertData);
            this.toast508Service.toFocus();
          }
          }  else {
            this.alertData = { message: this.translations['CAREER_RESUME_UPLOAD_NO_FILES'], type: 'warn' };
            this.viewCtrl.dismiss(this.alertData);
            this.toastService.presentToast(this.alertData);
            this.toast508Service.toFocus();
          }
        },
        // Optional. Called when the user closes the dialog without selecting a file
        // and does not include any parameters.
        cancel: function () { },
        // Optional. "preview" (default) is a preview link to the document for sharing,
        // "direct" is an expiring link to download the contents of the file. For more
        // information about link types, see Link types below.
        linkType: 'direct', // "direct" or "preview"
        // Optional. A value of false (default) limits selection to a single file, while
        // true enables multiple file selection.
        multiselect: false, // or true
        // Optional. This is a list of file extensions. If specified, the user will
        // only be able to select files with these extensions. You may also specify
        // file types, such as "video" or "images" in the list. For more information,
        // see File types below. By default, all extensions are allowed.
        extensions: ['.pdf', '.doc', '.docx'],
      };
      Dropbox.choose(this.options);
    } else {
      console.log('Browser is not supported.');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/components/upload-resume-popup/upload-resume-popup.component.ts